import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d86ae88")

_pushScopeId("data-v-0d86ae88")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "资产登记", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "折旧状态", -1)
const _hoisted_5 = { class: "flex button-group flexC" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_7 = { class: "flex flexR mar-t-22" }
const _hoisted_8 = { class: "flex flexC" }
const _hoisted_9 = { class: "c-ff" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = { class: "flex alignC detail" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, "收入日期", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, "收入类型", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, "类别", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, "关联单据", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "创建时间", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", null, "创建人", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, "状态", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", null, "审核时间", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, "审核人", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, "金额", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", null, "收款方式", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", null, "付款方", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", null, "联系电话", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", null, "经手人", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", null, "备注", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.roleList.create)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "mar-r-8 bg-red",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog_model = 'add'))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"108px"},
          placeholder: "请选择",
          modelValue: _ctx.screenParameter.status,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.status = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectChange($event,'status'))),
          clearable: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "已到期",
              value: "0"
            }),
            _createVNode(_component_el_option, {
              label: "未到期",
              value: "1"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_input, {
        style: {"width":"202px"},
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "搜索",
        clearable: "",
        "suffix-icon": "el-icon-search",
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectChange($event,'search')))
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "收入日期",
          align: "center",
          "min-width": "120"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              class: "text-center c-red",
              onClick: ($event: any) => {_ctx.dialog_model = 'detail'; _ctx.dialog_index = scope.$index}
            }, _toDisplayString(scope.row.create_time_text), 9, ["onClick"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "120"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_5, [
              (_ctx.roleList.edit)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: ($event: any) => {_ctx.dialog_model = 'edit'; _ctx.dialog_index = scope.$index}
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "新增",
      modelValue: _ctx.dialog_show,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialog_show = $event)),
      "model-value": _ctx.dialog_model == 'add' || _ctx.dialog_model == 'edit',
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      footer: _withId(() => [
        _createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode(_component_el_button, {
            class: "bg-red mar-r-16",
            onClick: _ctx._form_submit
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.dialog_model == 'add' ? '新增': '修改'), 1)
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_directive_loading, _ctx.form_load]
          ]),
          _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialog_model = ''))
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.form_rules,
          "label-width": "120px",
          style: {"width":"850px","margin":"0 auto"},
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "固定资产名称",
              prop: "fixed_name"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.fixed_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.fixed_name = $event)),
                  style: {"width":"280px"},
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "价值",
              prop: "fixed_price"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.fixed_price,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.fixed_price = $event)),
                  style: {"width":"280px"},
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "折旧期限",
              prop: "time"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.time,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.time = $event)),
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": "-",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  shortcuts: _ctx.shortcuts,
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenChange($event, 'formtime')))
                }, null, 8, ["modelValue", "shortcuts"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "成本承担部门",
              prop: "branch_id"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择",
                  modelValue: _ctx.form.branch_id,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.branch_id = $event)),
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"280px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.branch, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "fixed_type"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择",
                  modelValue: _ctx.form.fixed_type,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.fixed_type = $event)),
                  clearable: "",
                  disabled: _ctx.dialog_model == 'edit',
                  class: "mar-r-8",
                  style: {"width":"280px"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_option, {
                      label: "已有资产(仅登记资产折旧)",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "新采购资产(登记资产折旧，并生成支出记账)",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (_ctx.dialog_model != 'edit' &&　_ctx.form.fixed_type == 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "支出日期"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.form.expenditure_time,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.expenditure_time = $event)),
                      type: "date",
                      style: {"width":"280px"},
                      placeholder: "选择日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dialog_model != 'edit' &&　_ctx.form.fixed_type == 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "经手人"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择",
                      modelValue: _ctx.form.admin_id,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.admin_id = $event)),
                      clearable: "",
                      class: "mar-r-8",
                      style: {"width":"280px"}
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staff, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.nickname,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dialog_model != 'edit' &&　_ctx.form.fixed_type == 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "支付方式"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择",
                      modelValue: _ctx.form.pay_type,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.pay_type = $event)),
                      clearable: "",
                      class: "mar-r-8",
                      style: {"width":"280px"}
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.zf, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.basicset_name,
                            value: item.basicset_id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dialog_model != 'edit' &&　_ctx.form.fixed_type == 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "联系人"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.expenditure_phone,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.expenditure_phone = $event)),
                      style: {"width":"280px"},
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dialog_model != 'edit' &&　_ctx.form.fixed_type == 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 4,
                  label: "付款方"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.expenditure_payer,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.expenditure_payer = $event)),
                      style: {"width":"280px"},
                      placeholder: "请输入"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"400px"},
                  modelValue: _ctx.form.fixed_desc,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.fixed_desc = $event)),
                  type: "textarea",
                  row: "3",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]), [
          [_directive_loading, _ctx.dialog_load]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "model-value", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "记账详情",
      "model-value": _ctx.dialog_model == 'detail',
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].create_time_text), 1),
          _hoisted_13,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].pay_type_text), 1),
          _hoisted_14,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].expenditure_type), 1),
          _hoisted_15,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].ordersn), 1),
          _hoisted_16,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].create_time_text), 1),
          _hoisted_17,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].admin), 1),
          _hoisted_18,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].expenditure_status), 1),
          _hoisted_19,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].audit_time), 1),
          _hoisted_20,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].admin), 1),
          _hoisted_21,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].expenditure_price), 1),
          _hoisted_22,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].pay_type_text), 1),
          _hoisted_23,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].create_time_text), 1),
          _hoisted_24,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].expenditure_phone), 1),
          _hoisted_25,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].admin), 1),
          _hoisted_26,
          _createVNode("div", null, _toDisplayString(_ctx.tableData[_ctx.dialog_index].expenditure_desc), 1)
        ])
      ]),
      _: 1
    }, 8, ["model-value", "before-close"])
  ]))
})